
  export const orderStatusColors: Record<
    string,
    { bg: string; color: string }
  > = {
    PENDING: {
      bg: "#FFF7E6",
      color: "#D97706",
    },
    COMPLETED: {
      bg: "#E8F8EF",
      color: "var(--primary-color)",
    },
    PROCESSING: {
      bg: "#E8F1FF",
      color: "#2563EB",
    },
    APPROVED: {
      bg: "#E6F7F1",
      color: "#059669",
    },
    REJECTED: {
      bg: "#FDECEC",
      color: "#DC2626",
    },
  };